cv.PublicFundraisersRowView = Marionette.LayoutView.extend({
  tagName: "a",
  className: "fundraiser result",
  template: cv.Templates["public/fundraisers/fundraisers_row"],

  events: {},

  templateHelpers: function () {
    // If we don't have a user model this is a team
    if (_.isUndefined(this.model.get("display_name"))) {
      return {
        name: this.model.get("name"),
        meta:
          cv.formatMoney({
            amount: this.model.get("stats.display_funds_raised"),
            show_sign: true,
            currency_code: this.model.get("campaign.currency_code"),
            decimal_places: 0,
          }) + " Raised",
        photo_path: cv.photo({
          photo_path: this.model.get("avatar_image"),
          photo_default: this.model.get("campaign.default_team_image"),
          transforms: {
            fit: "crop",
          },
          url_only: true,
        }),
      };
    } else {
      return {
        name: this.model.get("display_name"),
        meta:
          cv.formatMoney({
            amount: this.model.get("stats.display_funds_raised"),
            show_sign: true,
            currency_code: this.model.get("campaign.currency_code"),
            decimal_places: 0,
          }) + " Raised",
        photo_path: cv.photo({
          photo_path: this.model.get("user.profile.avatar_image"),
          photo_default: this.model.get("campaign.default_project_image"),
          transforms: {
            fit: "crop",
          },
          url_only: true,
        }),
      };
    }
  },

  initialize: function (options) {
    console.log("PublicFundraisersRowView initialized");
  },

  onShow: function () {
    imgix.fluid(this.$el.get(0), {
      rootNode: this.$el.get(0),
      updateOnResizeDown: false,
      autoInsertCSSBestPractices: true,
    });

    if (_.isUndefined(this.model.get("display_name"))) {
      this.$el.attr("href", "/team/" + this.model.get("stub"));
    } else {
      this.$el.attr("href", "/" + this.model.get("stub"));
    }
  },
});
